import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, CheckCircleIcon, ArrowRightIcon, ChevronRightIcon, PlayCircleIcon, StarIcon, UsersIcon, ClockIcon, AwardIcon, MessageCircleIcon, TrendingUpIcon, FileTextIcon, SearchIcon, BriefcaseIcon, CompassIcon, ZapIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { ContactForm } from '../../components/ContactForm';
import { useSEO } from '../../hooks/useSEO';
import { useLanguage } from '../../context/LanguageContext';
function HeroSection() {
  return <section className="relative pt-20 lg:pt-24 pb-20 overflow-hidden bg-gradient-to-br from-amber-900 via-amber-800 to-navy-900" data-id="element-823">
      <div className="absolute inset-0" data-id="element-824">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-amber-500/10 blur-3xl hidden sm:block" data-id="element-825" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-orange-500/8 blur-3xl hidden sm:block" data-id="element-826" />
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,1) 1px, transparent 0)`,
        backgroundSize: '32px 32px'
      }} data-id="element-827" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-828">
        <motion.nav initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex items-center gap-1.5 text-sm text-amber-300/70 mb-10" data-id="element-829">
          <Link to="/" className="hover:text-amber-300 transition-colors" data-id="element-830">
            Головна
          </Link>
          <ChevronRightIcon className="w-3.5 h-3.5" data-id="element-831" />
          <Link to="/#services" className="hover:text-amber-300 transition-colors" data-id="element-832">
            Послуги
          </Link>
          <ChevronRightIcon className="w-3.5 h-3.5" data-id="element-833" />
          <span className="text-amber-200" data-id="element-834">Курс «Кар'єра»</span>
        </motion.nav>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-835">
          <div data-id="element-836">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.05
          }} className="flex items-center gap-3 mb-6" data-id="element-837">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 text-white shadow-xl shadow-amber-500/30" data-id="element-838">
                <BookOpenIcon className="w-6 h-6" data-id="element-839" />
              </div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-amber-500/20 text-amber-300 text-xs font-semibold rounded-full border border-amber-500/20" data-id="element-840">
                Авторський онлайн-курс
              </span>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.55,
            delay: 0.1
          }} data-id="element-841">
              <p className="text-amber-300/80 text-base font-medium mb-2" data-id="element-842">
                Авторський онлайн-курс Сергія Денисюка
              </p>
              <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.0]" data-id="element-843">
                КАР'ЄРА
              </h1>
              <p className="mt-3 text-xl text-amber-200/80 font-medium" data-id="element-844">
                Як досягти бажану посаду найефективнішим шляхом
              </p>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.18
          }} className="mt-5 text-lg text-amber-200/70 leading-relaxed" data-id="element-845">
              CEO і власника міжнародної агенції з підбору керівників ESCA.
              Жодної «води» — тільки суть. Повне перепакування за два тижні.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.25
          }} className="mt-8 flex flex-wrap gap-4" data-id="element-846">
              <a href="#contact" className="inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-amber-900 bg-white rounded-xl hover:bg-amber-50 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-847">
                Отримати вступний урок безкоштовно
                <ArrowRightIcon className="w-4 h-4" data-id="element-848" />
              </a>
              <a href="#pricing" className="inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-white border border-white/20 rounded-xl hover:bg-white/10 transition-all" data-id="element-849">
                Тарифи
              </a>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4" data-id="element-850">
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-851">
              <div className="text-4xl font-extrabold text-white" data-id="element-852">5</div>
              <div className="text-sm text-amber-300/70 mt-1" data-id="element-853">відео-уроків</div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-854">
              <div className="text-4xl font-extrabold text-amber-400" data-id="element-855">2</div>
              <div className="text-sm text-amber-300/70 mt-1" data-id="element-856">
                тижні до результату
              </div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-857">
              <div className="text-4xl font-extrabold text-white" data-id="element-858">20+</div>
              <div className="text-sm text-amber-300/70 mt-1" data-id="element-859">
                років досвіду автора
              </div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-860">
              <div className="text-4xl font-extrabold text-amber-400" data-id="element-861">
                від $300
              </div>
              <div className="text-sm text-amber-300/70 mt-1" data-id="element-862">
                вартість курсу
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function WhatYouGetSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const items = [{
    icon: PlayCircleIcon,
    text: '5 відео-уроків з можливістю перегляду у зручний час'
  }, {
    icon: FileTextIcon,
    text: 'Домашні завдання з перевіркою (крім тарифу «Стандартний»)'
  }, {
    icon: BookOpenIcon,
    text: 'Розбір реальних кейсів із практики'
  }, {
    icon: SearchIcon,
    text: 'Список сайтів та чатів вакансій топ-менеджерів, сайтів з рівнями доходів та відгуками про роботодавців'
  }, {
    icon: BookOpenIcon,
    text: 'Список рекомендованої літератури'
  }, {
    icon: MessageCircleIcon,
    text: 'Відео-зустріч з автором курсу (крім тарифу «Стандартний»). У тарифі «Преміум» — 5 фідбек-сесій'
  }, {
    icon: UsersIcon,
    text: 'Резюме учасників курсу потрапляють до бази ESCA — ми працюємо з ними при надходженні релевантних запитів'
  }];
  return <section className="py-20 lg:py-28 bg-white" ref={ref} data-id="element-863">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-864">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-865">
          <span className="text-sm font-semibold text-amber-600 tracking-wide uppercase" data-id="element-866">
            Що входить до курсу
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-867">
            Завдання — повністю перепакувати вас за два тижні
          </h2>
          <p className="mt-4 text-lg text-navy-500 max-w-2xl mx-auto" data-id="element-868">
            Жодної «води». Тільки суть. За результатами проходження у вас буде
            резюме, що продає, стратегія досягнення потрібної позиції та
            розуміння всіх нюансів побудови кар'єри.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-869">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className="flex items-start gap-4 p-5 rounded-2xl bg-amber-50/60 border border-amber-100" data-id="element-870">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 text-white flex items-center justify-center flex-shrink-0 shadow-md shadow-amber-500/20" data-id="element-871">
                <item.icon className="w-4 h-4" data-id="element-872" />
              </div>
              <p className="text-sm text-navy-700 leading-relaxed pt-1.5" data-id="element-873">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mt-10 p-6 rounded-2xl bg-navy-900 text-center max-w-2xl mx-auto" data-id="element-874">
          <p className="text-white font-semibold mb-1" data-id="element-875">
            Безкоштовний вступний урок
          </p>
          <p className="text-navy-400 text-sm" data-id="element-876">
            Залиште заявку у формі нижче — і ми надішлемо вступний урок до курсу
            «Кар'єра»
          </p>
        </motion.div>
      </div>
    </section>;
}
function ModulesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const modules = [{
    num: '01',
    title: "Кар'єрна стратегія. Побудова власного бренду. Тайм-менеджмент",
    topics: ['Визначення точки старту та мети', "Типи кар'єри та стратегія досягнення мети", "Особиста кар'єрна перевага", 'Побудова особистого бренду', 'Мистецтво тайм-менеджменту']
  }, {
    num: '02',
    title: 'Підготовка резюме. Створення резюме, що продає',
    topics: ['Розмір резюме та його формат', 'Яка інформація має бути у резюме', 'Як відбувається відбір резюме', 'Секрети та лайфхаки резюме, що продає', 'Приклади типових помилок у реальних резюме']
  }, {
    num: '03',
    title: 'Пошук найкращих вакансій. Зміна сфери',
    topics: ['Шляхи пошуку роботи', 'Використання LinkedIn та Facebook', 'Нетворкінг для пошуку роботи', 'Рекомендації щодо зміни сфери', 'Типові помилки під час пошуку'],
    extra: 'Додатково: сайти та канали вакансій'
  }, {
    num: '04',
    title: "Підготовка до інтерв'ю. Переговори щодо доходу",
    topics: ['Як отримати повну інформацію про компанію', 'Підготовка самопрезентації та до можливих питань', "Відмінності в інтерв'ю з агентствами, HR та керівництвом", "Нюанси онлайн-інтерв'ю", 'Оцінка вартості на ринку та обговорення зарплати'],
    extra: 'Додатково: сайти за рівнем доходів та відгуками про роботодавців'
  }, {
    num: '05',
    title: "Випробувальний термін. Кар'єрне зростання. Найм vs бізнес",
    topics: ['Успішний старт та план на випробувальний термін', 'Що робити, якщо робота не відповідає очікуванням', 'Оцінка перспектив зростання в компанії', 'Робота за наймом чи власний бізнес — що зважити']
  }, {
    num: '06',
    title: 'Відео-зустріч з автором курсу',
    topics: ['Індивідуальна сесія з Сергієм Денисюком', 'Відповіді на особисті запитання', 'Розбір вашої конкретної ситуації'],
    highlight: true
  }];
  return <section className="py-20 lg:py-28 bg-navy-50/40" ref={ref} data-id="element-877">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-878">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-879">
          <span className="text-sm font-semibold text-amber-600 tracking-wide uppercase" data-id="element-880">
            Програма
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-881">
            Структура курсу
          </h2>
          <p className="mt-4 text-lg text-navy-500 max-w-2xl mx-auto" data-id="element-882">
            5 відео-уроків + відео-зустріч з автором. Два відео-уроки на тиждень
            — старт протягом доби після оплати.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-883">
          {modules.map((mod, i) => <motion.div key={mod.num} initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`p-7 rounded-2xl border ${mod.highlight ? 'bg-gradient-to-br from-amber-500 to-amber-600 border-amber-400' : 'bg-white border-navy-100'}`} data-id="element-884">
              <div className={`text-5xl font-extrabold mb-4 leading-none ${mod.highlight ? 'text-white/30' : 'text-navy-100'}`} data-id="element-885">
                {mod.num}
              </div>
              <h3 className={`text-base font-bold mb-4 leading-snug ${mod.highlight ? 'text-white' : 'text-navy-900'}`} data-id="element-886">
                {mod.title}
              </h3>
              <ul className="space-y-2" data-id="element-887">
                {mod.topics.map((topic, j) => <li key={j} className="flex items-start gap-2" data-id="element-888">
                    <CheckCircleIcon className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${mod.highlight ? 'text-white/70' : 'text-amber-500'}`} data-id="element-889" />
                    <span className={`text-xs leading-relaxed ${mod.highlight ? 'text-amber-100' : 'text-navy-500'}`} data-id="element-890">
                      {topic}
                    </span>
                  </li>)}
              </ul>
              {mod.extra && <div className={`mt-4 pt-4 border-t text-xs font-medium ${mod.highlight ? 'border-white/20 text-amber-200' : 'border-navy-100 text-amber-600'}`} data-id="element-891">
                  📎 {mod.extra}
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}
function PricingSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const plans = [{
    name: 'Стандартний',
    price: '$300',
    features: ['Старт протягом доби після оплати', 'Два відео-уроки на тиждень', '5 відео-уроків (перегляд у зручний час)', 'Домашні завдання без перевірки', 'Додаткові матеріали', 'Доступ до матеріалів на 1 місяць'],
    cta: 'Обрати тариф',
    highlight: false
  }, {
    name: 'Просунутий',
    price: '$550',
    features: ['Старт протягом доби після оплати', 'Два відео-уроки на тиждень', '5 відео-уроків (перегляд у зручний час)', 'Домашні завдання з перевіркою (протягом 3 днів)', 'Додаткові матеріали', 'Індивідуальна відео-зустріч з автором (~1 година)', 'Доступ до матеріалів на 2 місяці'],
    cta: 'Обрати тариф',
    highlight: true
  }, {
    name: 'Преміум',
    price: '$950',
    features: ['Старт протягом доби після оплати', 'Індивідуальний графік', '5 відео-уроків (перегляд у зручний час)', 'Домашні завдання з перевіркою', 'Додаткові матеріали', '5 фідбек-сесій з автором курсу', 'Доступ до матеріалів на 3 місяці'],
    cta: 'Обрати тариф',
    highlight: false
  }];
  return <section className="py-20 lg:py-28 bg-white" id="pricing" ref={ref} data-id="element-892">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-893">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-894">
          <span className="text-sm font-semibold text-amber-600 tracking-wide uppercase" data-id="element-895">
            Тарифи
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-896">
            Оберіть свій формат
          </h2>
          <p className="mt-4 text-lg text-navy-500 max-w-xl mx-auto" data-id="element-897">
            Для отримання безкоштовного вступного уроку — залиште заявку у формі
            нижче
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start" data-id="element-898">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`relative rounded-2xl border overflow-hidden ${plan.highlight ? 'bg-gradient-to-b from-amber-500 to-amber-600 border-amber-400 shadow-2xl shadow-amber-500/25' : 'bg-white border-navy-100 shadow-sm'}`} data-id="element-899">
              {plan.highlight && <div className="absolute top-0 left-0 right-0 h-1 bg-white/30" data-id="element-900" />}
              {plan.highlight && <div className="text-center py-2 bg-white/15" data-id="element-901">
                  <span className="text-xs font-bold text-white uppercase tracking-widest" data-id="element-902">
                    Найпопулярніший
                  </span>
                </div>}
              <div className="p-8" data-id="element-903">
                <h3 className={`text-lg font-bold mb-1 ${plan.highlight ? 'text-white' : 'text-navy-900'}`} data-id="element-904">
                  «{plan.name}»
                </h3>
                <div className={`text-4xl font-extrabold mb-6 ${plan.highlight ? 'text-white' : 'text-navy-900'}`} data-id="element-905">
                  {plan.price}
                </div>
                <ul className="space-y-3 mb-8" data-id="element-906">
                  {plan.features.map((f, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-907">
                      <CheckCircleIcon className={`w-4 h-4 flex-shrink-0 mt-0.5 ${plan.highlight ? 'text-white/80' : 'text-amber-500'}`} data-id="element-908" />
                      <span className={`text-sm leading-relaxed ${plan.highlight ? 'text-amber-100' : 'text-navy-600'}`} data-id="element-909">
                        {f}
                      </span>
                    </li>)}
                </ul>
                <a href="#contact" className={`block text-center px-6 py-3.5 rounded-xl font-semibold text-sm transition-all ${plan.highlight ? 'bg-white text-amber-700 hover:bg-amber-50 shadow-lg' : 'bg-amber-500 text-white hover:bg-amber-600 shadow-md shadow-amber-500/20'}`} data-id="element-910">
                  {plan.cta}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
function CommunitiesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="py-16 bg-navy-50/40" ref={ref} data-id="element-911">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-912">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-10" data-id="element-913">
          <span className="text-sm font-semibold text-amber-600 tracking-wide uppercase" data-id="element-914">
            Спільноти
          </span>
          <h2 className="mt-3 text-2xl sm:text-3xl font-extrabold text-navy-900 tracking-tight" data-id="element-915">
            Міжнародні чати вакансій від ESCA
          </h2>
          <p className="mt-3 text-navy-500" data-id="element-916">
            Приєднуйтесь до наших Telegram-спільнот з актуальними вакансіями
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto" data-id="element-917">
          {[{
          name: 'Executive Search UA',
          desc: 'Дохід від $2 000',
          link: 'https://t.me/executive_search_ua',
          color: 'from-navy-700 to-navy-900'
        }, {
          name: 'Premium Job UA',
          desc: 'Дохід від $5 000',
          link: 'https://t.me/premium_job_ua',
          color: 'from-amber-600 to-amber-800'
        }, {
          name: 'IT Job UA',
          desc: 'IT вакансії',
          link: 'https://t.me/it_job_ua',
          color: 'from-violet-700 to-violet-900'
        }].map((community, i) => <motion.a key={community.name} href={community.link} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 16
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className={`p-6 rounded-2xl bg-gradient-to-br ${community.color} text-white text-center hover:-translate-y-1 transition-transform`} data-id="element-918">
              <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center mx-auto mb-3" data-id="element-919">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-920">
                  <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0h-.056zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-921" />
                </svg>
              </div>
              <div className="font-bold text-sm" data-id="element-922">{community.name}</div>
              <div className="text-xs text-white/70 mt-1" data-id="element-923">{community.desc}</div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}
function CtaBanner() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5
  }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-924">
      <div className="p-8 sm:p-12 rounded-3xl bg-gradient-to-br from-amber-900 via-amber-800 to-navy-900 relative overflow-hidden" data-id="element-925">
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-amber-500/15 blur-3xl hidden sm:block" data-id="element-926" />
        <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-orange-400/10 blur-3xl hidden sm:block" data-id="element-927" />
        <div className="relative z-10 flex flex-col sm:flex-row items-center gap-6 sm:gap-10" data-id="element-928">
          <div className="flex-1" data-id="element-929">
            <h3 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight" data-id="element-930">
              Отримайте вступний урок безкоштовно
            </h3>
            <p className="mt-2 text-amber-200/80 leading-relaxed" data-id="element-931">
              Залиште заявку — і ми надішлемо перший урок курсу «Кар'єра» та
              відповімо на ваші запитання.
            </p>
          </div>
          <a href="#contact" className="flex-shrink-0 inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-amber-900 bg-white rounded-xl hover:bg-amber-50 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-932">
            Залишити заявку
            <ArrowRightIcon className="w-4 h-4" data-id="element-933" />
          </a>
        </div>
      </div>
    </motion.div>;
}
const seoData = {
  UA: {
    title: "Курс «Кар'єра» — Онлайн-курс Сергія Денисюка | ESCA",
    description: "Авторський онлайн-курс «Кар'єра» від CEO ESCA Сергія Денисюка. 5 відео-уроків, побудова кар'єрної стратегії, резюме що продає. Від $300.",
    keywords: "курс кар'єра, кар'єрний консалтинг, резюме, пошук роботи, Сергій Денисюк, ESCA"
  },
  RU: {
    title: 'Курс «Карьера» — Онлайн-курс Сергея Денисюка | ESCA',
    description: 'Авторский онлайн-курс «Карьера» от CEO ESCA Сергея Денисюка. 5 видео-уроков, построение карьерной стратегии, продающее резюме. От $300.',
    keywords: 'курс карьера, карьерный консалтинг, резюме, поиск работы, Сергей Денисюк, ESCA'
  },
  EN: {
    title: 'Career Course — Online Course by Sergiy Denysyuk | ESCA',
    description: "Author's online career course by ESCA CEO Sergiy Denysyuk. 5 video lessons, career strategy, selling resume. From $300.",
    keywords: 'career course, career consulting, resume, job search, Sergiy Denysyuk, ESCA'
  }
};
export function CareerConsultingPage() {
  const {
    lang
  } = useLanguage();
  const seo = seoData[lang];
  useSEO({
    title: seo.title,
    description: seo.description,
    keywords: seo.keywords
  });
  return <div className="min-h-screen w-full bg-white overflow-x-hidden" data-id="element-934">
      <Header data-id="element-935" />
      <main className="pt-16 lg:pt-20" data-id="element-936">
        <HeroSection data-id="element-937" />
        <WhatYouGetSection data-id="element-938" />
        <ModulesSection data-id="element-939" />
        <PricingSection data-id="element-940" />
        <CommunitiesSection data-id="element-941" />
        <CtaBanner data-id="element-942" />
        <div id="contact" data-id="element-943">
          <ContactForm data-id="element-944" />
        </div>
      </main>
      <Footer data-id="element-945" />
    </div>;
}